export var EmployeeIssue;
(function (EmployeeIssue) {
    EmployeeIssue[EmployeeIssue["NoTimeTable"] = 0] = "NoTimeTable";
    EmployeeIssue[EmployeeIssue["TimeTableWithoutHours"] = 1] = "TimeTableWithoutHours";
    EmployeeIssue[EmployeeIssue["ProductivityNotSet"] = 2] = "ProductivityNotSet";
})(EmployeeIssue || (EmployeeIssue = {}));
